import { render, staticRenderFns } from "./CommissionWindow.vue?vue&type=template&id=2bac8b3b&scoped=true&lang=pug&"
import script from "./CommissionWindow.vue?vue&type=script&lang=ts&"
export * from "./CommissionWindow.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionWindow.vue?vue&type=style&index=0&id=2bac8b3b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bac8b3b",
  null
  
)

export default component.exports